var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container", attrs: { id: "app" } },
    [
      _c("preloader"),
      _vm._v(" "),
      _c(
        "a",
        {
          directives: [
            {
              name: "longpress",
              rawName: "v-longpress",
              value: _vm.onLogoLongpress,
              expression: "onLogoLongpress"
            }
          ],
          staticClass: "site-logo",
          attrs: { href: "/", "data-dont-hide-panels": "" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return (function() {})($event)
            },
            mousedown: _vm.onLogoPress,
            mouseup: _vm.onLogoRelease
          }
        },
        [
          _c("img", {
            attrs: {
              src: _vm.showAnimatedLogo ? _vm.logoAnimated : _vm.logo,
              alt: "Logo"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("event-and-contact-panel"),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "bar",
              rawName: "v-bar",
              value: { overrideFloatingScrollbar: true },
              expression: "{ overrideFloatingScrollbar: true }"
            }
          ],
          ref: "scrollContainer",
          staticClass: "scroll-container"
        },
        [
          _c("div", { on: { scroll: _vm.onScroll } }, [
            _c(
              "main",
              { staticClass: "container" },
              [
                _c("site-header", { ref: "header" }),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { name: "route-fade", mode: "out-in" } },
                  [
                    _c("router-view", {
                      key: _vm.$route.params.slug || _vm.$route.path
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("archive-panel"),
      _vm._v(" "),
      _c("panel-controls"),
      _vm._v(" "),
      _c("panel-close-hotspots")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }